<template>
  <div>




    <div class="row">
      <div class="col">
        <div class="card p-5">

          <div class="row mb-2" >
            <div class="col-12">
               <h1 v-if="selectedAccount &&accounts.length==1">{{ selectedAccount.name }}</h1>
                <v-select
                  v-if="accounts.length>1"
                  label="name"
                  :options="accounts"
                  v-show="!loading"
                  v-model="selectedAccount"
                >
                  <template slot="option" slot-scope="p">
                    <div>
                      {{ p.name }} - {{ p.contact_number }}<br />
                      {{ p.email_address }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="p">
                    {{ p.name }}                     
                  </template>
                </v-select>
            </div>
            
          </div>

          <div class="row mt-2">
            <div class="col-12">
              <h3>Jobs Summary</h3>
              <p>Current open jobs and jobs closed in the past 30 days</p>
              <a v-if="selectedAccount" :href="`/partner-reports/account/${selectedAccount.id}/jobs?cid=${selectedAccount.company_id}`" class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr>
            </div>
          </div>

          
          <div class="row mt-2">
            <div class="col-12">
              <h3>Shipping Summary</h3>
               <p>Current jobs in transit, and awaiting shipping</p>
               <a v-if="selectedAccount" :href="`/partner-reports/account/${selectedAccount.id}/shipping?cid=${selectedAccount.company_id}`" class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr>
            </div>
          </div>

           <div class="row mt-2">
            <div class="col-12">
              <h3>Client Summary</h3>
               <p>List of clients with an outstanding balance</p>
               <a v-if="selectedAccount" :href="`/partner-reports/account/${selectedAccount.id}/clients-outstanding-balances?cid=${selectedAccount.company_id}`" class="btn btn-sm btn-primary">
                Export Excel
              </a>
              <hr>
            </div>
          </div>
          
          <div class="row mt-2">
            <div class="col-12">

               
              <h3>Account Statement</h3>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <label for="from">From</label>
                  <b-form-datepicker
                    id="from"
                    v-model="from"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <label for="to">To</label>
                  <b-form-datepicker
                    id="to"
                    v-model="to"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
                <div class="col-md-4">
                  <p class="font-weight-bold">Max 1 year range</p>
                  
                  <button
                    @click="printStatement"
                    class="btn btn-sm btn-primary ml-2"
                  >
                    Print
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import partnerAccountRepo from "@/api/repos/partnerAccountRepo";
export default {

   mounted() {
    this.getAccounts();
  },

  data() {
    return {    
      selectedAccount:null,
      accounts:[],
      loading:false,
      from: this.moment().subtract(3, 'months').format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
    };
  },

  methods:{
    async getAccounts() {
      this.loading = true
      try {
        let { data } = await partnerAccountRepo.accounts();
        this.accounts = data.accounts
        this.selectedAccount = this.accounts[0]
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async printStatement() {

      //from is not greate
      if(this.moment(this.from).isAfter(this.moment(this.to))){
          this.$root.$bvToast.toast("From can not be after to", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      //not more then a year
       if(this.moment(this.to).diff(this.moment(this.from), 'days') > 366){
          this.$root.$bvToast.toast("Range can not be greater than 1 year", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      window.open(`/pdf/reports/account/${this.selectedAccount.account.id}/partner-statement?from=${this.from}&to=${this.to}&cid=${localStorage.getItem('current_company_id')}`)
     
    },
  }
};
</script>

<style>
</style>